<!--
  ~ VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

  <div class="mobile-top-bar" *ngIf="isMobileScreen && !isMobileSearch">
      <div class="left-side">
          <div>
              <button mat-icon-button (click)="routeToMail()">
                  <mat-icon>chevron_left</mat-icon>
              </button>
          </div>
          <div class="tab-header">
              {{ 'OWNCLOUD' | translate }}
          </div>
      </div>
      <div class="right-side">
         <vnc-icon-container class="search-icon" (click)="showFilterSearchFormFormMobile()">
          <ng-container [ngTemplateOutlet]="searchIcon"></ng-container>
        </vnc-icon-container>
      </div>
</div>

<div *ngIf="isMobileScreen && isMobileSearch" class="mobile-search-task-div mobile-top-bar">
            <div class="btutton-section">
                <button mat-icon-button (click)="clearSearch()">
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
            <div class="search-field mobile-search-field">
               <input id="quickFilterInputData" [formControl]="searchControl"
                  placeholder="{{ 'CALENDARS.SEARCH' | translate }}">
            </div>
            <div>
                <button mat-icon-button (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
</div>

  <vnc-header *ngIf="isDialog" style="width:100%;"
        title="{{ 'OWNCLOUD' | translate }}"
        type="title-close"
        size="l"
        (onCloseClick)="onEsc()"
        [showCloseIcon]="true"
        >
    </vnc-header>
  <div class="owncloud-chips">
    <vnc-chips (clickEvent)="filterBy('all')" text="{{ 'ALL_FILES' | translate}}" [active]="currentFilter.value === 'all'" type="static" size="s"></vnc-chips>
    <vnc-chips (clickEvent)="filterBy('favorites')" text="{{ 'FAVORITES' | translate}}" [active]="currentFilter.value  === 'favorites'" type="static" size="s"></vnc-chips>
    <vnc-chips (clickEvent)="filterBy('shared_with_you')" text="{{ 'SHARED_WITH_YOU' | translate}}" [active]="currentFilter.value  === 'shared_with_you'" type="static" size="s"></vnc-chips>
    <vnc-chips (clickEvent)="filterBy('shared_with_others')" text="{{ 'SHARED_WITH_OTHERS' | translate}}" [active]="currentFilter.value  === 'shared_with_others'" type="static" size="s"></vnc-chips>
    <vnc-chips (clickEvent)="filterBy('shared_by_link')" text="{{ 'SHARED_BY_LINK' | translate}}" [active]="currentFilter.value  === 'shared_by_link'" type="static" size="s"></vnc-chips>
   <vnc-smart-link-filter-chip label="{{ 'TAGS' | translate}}" [disableApplyOnChange]="true" *ngIf="tags.length > 0"
   customClass="dropdown-with-footer" [useMenuItem]="true" [showClearIcon]="true"
   (apply)="filterByTags($event)"
   searchPlaceholder="{{ 'SEARCH' | translate}}"
   applyLabel="{{ 'APPLY' | translate}}" cancelLabel="{{ 'CANCEL' | translate}}"
   (clearFilter)="filterByTags($event)" [prefixIconTemplate]="tagIcon" [multiple]="true" type="ONLY_SELECT"
    [options]="tags"

    [showSearchBox]="true"></vnc-smart-link-filter-chip>
  </div>
<div class="owncloud-component"  [class.with-dialog]="isDialog" *ngIf="!isMobileSize()">
  <div class="owncloud-navigation">
    <div class="home-icon">
      <vnc-icon-container (click)="home()">
        <ng-container [ngTemplateOutlet]="homeIcon">
        </ng-container>
      </vnc-icon-container>
      <span class="home-folder" (click)="home()">{{ 'OWNCLOUD' | translate }}</span>
    </div>
    <ng-container *ngIf="currentFolder && currentFilter.value === 'all'">
      <div class="separator-icon">
        <ng-container [ngTemplateOutlet]="separatorIcon">
        </ng-container>
      </div>
      <div class="more-text" (click)="backPreviousFolder()">
        ...
      </div>
      <div class="separator-icon">
        <ng-container [ngTemplateOutlet]="separatorIcon">
        </ng-container>
      </div>
      <div class="current-folder">
        {{ currentFolder?.name }}
      </div>
    </ng-container>
    <div class="add-icon-oc" *ngIf="currentFilter.value === 'all'">
      <button class="document-kebab-menu-btn" #addMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="addMenu" matTooltip="{{ 'ADD' | translate }}">
        <vnc-action-panel [iconTemplate]="addIcon" [type]="'action'" [isPending]="false" [actionColor]="'white'">
        </vnc-action-panel>
      </button>

      <mat-menu class="document-kebab-menu" #addMenu="matMenu" [overlapTrigger]="false">
        <ng-template matMenuContent>
          <vp-dropdown-item itemType="menu-item" (click)="newFolder()" [prefixIconTemplate]="newFolderIcon"
            label="{{ 'NEW_FOLDER' | translate }}"></vp-dropdown-item>
          <vp-dropdown-item itemType="menu-item" (click)="uploadFile()" [prefixIconTemplate]="uploadFileIcon"
            label="{{ 'UPLOAD_FILE' | translate }}"></vp-dropdown-item>
        </ng-template>
      </mat-menu>
    </div>

    <div class="ui-progressbar" *ngIf="(uploading | async)">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      {{ 'UPLOADING_FILE' | translate }}
    </div>
    <vnc-icon-container *ngIf="(uploading | async)" class="cancel-upload-action" matTooltip="{{ 'CANCEL' | translate }}" (click)="cancelUpload()">
      <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Icon/product/close-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M18.9497475,5.05025253 C19.3402718,5.44077682 19.3402718,6.0739418 18.9497475,6.46446609 L13.4142136,12 L18.9497475,17.5355339 C19.3402718,17.9260582 19.3402718,18.5592232 18.9497475,18.9497475 C18.5592232,19.3402718 17.9260582,19.3402718 17.5355339,18.9497475 L12,13.4142136 L6.46446609,18.9497475 C6.0739418,19.3402718 5.44077682,19.3402718 5.05025253,18.9497475 C4.65972824,18.5592232 4.65972824,17.9260582 5.05025253,17.5355339 L10.5857864,12 L5.05025253,6.46446609 C4.65972824,6.0739418 4.65972824,5.44077682 5.05025253,5.05025253 C5.44077682,4.65972824 6.0739418,4.65972824 6.46446609,5.05025253 L12,10.5857864 L17.5355339,5.05025253 C17.9260582,4.65972824 18.5592232,4.65972824 18.9497475,5.05025253 Z" id="Path" fill="#8B96A0"></path>
          </g>
      </svg>
    </vnc-icon-container>
  </div>
  <div class="selection-info" *ngIf="selection.selected.length > 0">
    <div class="selection-left">
      <div class="selection-text">{{ selectionText }}</div>
      <vnc-icon-container (click)="downloadAll()" matTooltip="{{ 'DOWNLOAD_SELECTED' | translate }}">
        <ng-container [ngTemplateOutlet]="downloadIcon">
        </ng-container>
      </vnc-icon-container>
      <vnc-icon-container (click)="deleteAll()" matTooltip="{{ 'DELETE_ALL' | translate }}">
        <ng-container [ngTemplateOutlet]="deleteIcon">
        </ng-container>
      </vnc-icon-container>
    </div>
    <vnc-icon-container class="reset-all" (click)="resetSelection()" matTooltip="{{ 'CLOSE' | translate }}">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fill-rule="evenodd">
          <g fill="#000">
            <g>
              <g>
                <g>
                  <path
                    d="M14.212 3.788c.293.293.293.767 0 1.06L10.061 9l4.151 4.152c.293.293.293.767 0 1.06-.293.293-.767.293-1.06 0L9 10.061l-4.152 4.151c-.293.293-.767.293-1.06 0-.293-.293-.293-.767 0-1.06L7.939 9 3.788 4.848c-.293-.293-.293-.767 0-1.06.293-.293.767-.293 1.06 0L9 7.939l4.152-4.151c.293-.293.767-.293 1.06 0z"
                    transform="translate(-1113.000000, -402.000000) translate(219.000000, 387.000000) translate(50.000000, 0.000000) translate(844.000000, 15.000000)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </vnc-icon-container>
  </div>
  <div class="owncloud-search-form">
    <vnc-input leadingIconName="mdi-magnify" [form]="searchControl" [showClear]="true"
      placeholder="{{'SEARCH'|translate}}" size="l" type="text" clearTooltip="{{ 'CLEAR' | translate}}">
    </vnc-input>
  </div>
  <div [class.show-send-chat-footer]="selection.selected.length > 0 && !!selectedTarget" class="owncloud-files vnc-scroll-bar--medium--vertical" [class.min-height]="fileToUpdate">
    <table *ngIf="!currentFilter.value.startsWith('shared')" mat-table [dataSource]="dataSource"
      class="mat-elevation-z8 vnc-scroll-bar--medium--vertical">

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> {{ 'NAME' | translate }} </th>
        <td mat-cell *matCellDef="let element">
          <div class="item-info">
            <div class="item-icon" *ngIf="element.type === 'dir'">
              <ng-container [ngTemplateOutlet]="folderIcon">
              </ng-container>
            </div>
            <ng-container *ngIf="element.type !== 'dir'">
              <ng-container [ngSwitch]="element.fileType">
                <div class="item-icon with-background" *ngSwitchDefault>
                  <ng-container [ngTemplateOutlet]="markupIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Pdf'">
                  <ng-container [ngTemplateOutlet]="pdfIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Word'">
                  <ng-container [ngTemplateOutlet]="wordIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Video'">
                  <ng-container [ngTemplateOutlet]="videoIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Autocad'">
                  <ng-container [ngTemplateOutlet]="cadIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'ApplePages'">
                  <ng-container [ngTemplateOutlet]="appleIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'XML'">
                  <ng-container [ngTemplateOutlet]="xmlIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Markup'">
                  <ng-container [ngTemplateOutlet]="markupIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Illustrator'">
                  <ng-container [ngTemplateOutlet]="aiIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Photoshop'">
                  <ng-container [ngTemplateOutlet]="psdIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'TaggedImage'">
                  <ng-container [ngTemplateOutlet]="tiffIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Vector'">
                  <ng-container [ngTemplateOutlet]="svgIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'PostScript'">
                  <ng-container [ngTemplateOutlet]="scriptIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'TrueType'">
                  <ng-container [ngTemplateOutlet]="ttfIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Powerpoint'">
                  <ng-container [ngTemplateOutlet]="powerpointIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Text'">
                  <ng-container [ngTemplateOutlet]="txtIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Archive'">
                  <ng-container [ngTemplateOutlet]="zipIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Excel'">
                  <ng-container [ngTemplateOutlet]="excelIcon">
                  </ng-container>
                </div>
                <div class="item-icon" *ngSwitchCase="'Image'">
                  <div class="thumbnail" *ngIf="isNextCloud">
                    <img src="{{ getNextCloudPreviewUrl(element.fileId) }}" alt="" crossorigin="use-credentials" style="height: 36px; width: 36px;">
                  </div>
                  <div class="thumbnail" *ngIf="!isNextCloud">
                    <img src="{{ element.urlV2 }}?x=36&y=36&forceIcon=0&preview=1" alt="" crossorigin="use-credentials">
                  </div>

                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Sound'">
                  <ng-container [ngTemplateOutlet]="audioIcon">
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
            <div class="item-name">
              <span *ngIf="element.type === 'file'" (click)="previewDocument(element)">{{element.name}}</span>
              <ng-container *ngIf="element.type !== 'file'">{{element.name}}</ng-container>
              <div (click)="$event.stopPropagation();$event.preventDefault()"
                *ngIf="fileToUpdate && fileToUpdate.fileId === element.fileId" class="rename-form">
                <vnc-input #renameInput [form]="itemNameControl"></vnc-input>
                <vnc-primary-button (onClick)="updateFile(element)"
                  (click)="$event.stopPropagation();$event.preventDefault()" [leadingIconName]="'mdi-check'"
                  [size]="'l'" [isPending]="isPending"></vnc-primary-button>
                <vnc-secondary-button (onClick)="cancelUpdate()"
                  (click)="$event.stopPropagation();$event.preventDefault()" [size]="'l'" [isPending]="false"
                  [leadingIconName]="'mdi-close'"></vnc-secondary-button>

              </div>
            </div>
          </div>

        </td>
      </ng-container>

      <!-- Shared Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <div class="file-actions">
            <button class="document-kebab-menu-btn" (click)="$event.stopPropagation();"
              #shareMenuTrigger="matMenuTrigger" mat-icon-button [matMenuTriggerFor]="shareMenu" matTooltip="{{ 'SHARE' | translate }}">
              <ng-container [ngTemplateOutlet]="shareIcon">
              </ng-container>
            </button>
            <mat-menu class="owncloud-menu" #shareMenu="matMenu" [overlapTrigger]="false">
              <ng-template matMenuContent [ngTemplateOutlet]="shareMenuTemplate"
                [ngTemplateOutletContext]="{'file': element}">
              </ng-template>
            </mat-menu>
            <span (click)="$event.stopPropagation();" *ngIf="element.shareTypes !== ''" class="shared-text">
              {{ 'SHARED' | translate }}
            </span>
            <span (click)="$event.stopPropagation();" *ngIf="getSharedOwner(element) && (element?.ownerDisplayName.indexOf('@') === -1)" class="shared-text">
              {{element?.ownerDisplayName}}
            </span>
            <span (click)="$event.stopPropagation();" *ngIf="getSharedOwner(element) && (element?.ownerDisplayName.indexOf('@') > -1)" class="shared-text">
                <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Icon/vnc/iom-new-grayscale" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="matrix(0.22297838,0,0,0.22297838,1.4004701,1.6713882)">
                    <circle id="Oval" fill="#a8b0b9" fill-rule="nonzero" cx="48" cy="48" r="48" />
                    <path d="M 55.071068,19.715729 69.354797,33.999797 53.999,33.999229 54,30.273229 c 0,-0.250186 -0.09378,-0.491289 -0.262846,-0.675719 -0.373192,-0.407119 -1.00576,-0.434622 -1.412879,-0.06143 v 0 L 42,39 52.324275,48.463919 c 0.18443,0.169061 0.425533,0.262846 0.675725,0.262846 0.552285,0 1,-0.447715 1,-1 v 0 l -10e-4,-3.727536 24.382473,0.0012 c 1.595017,3.658954 0.89595,8.077466 -2.097202,11.070618 L 55.071068,76.284271 c -3.905243,3.905243 -10.236893,3.905243 -14.142136,0 L 26.643797,61.999797 42,61.999229 v 3.727536 c 0,0.250192 0.09378,0.491295 0.262846,0.675725 0.373192,0.407119 1.00576,0.434622 1.412879,0.06143 v 0 L 54,57 43.675725,47.536081 C 43.491295,47.36702 43.250192,47.273235 43,47.273235 c -0.552285,0 -1,0.447715 -1,1 v 0 3.725994 l -24.381035,0.0013 C 16.023382,48.341406 16.722303,43.922358 19.715729,40.928932 L 40.928932,19.715729 c 3.905243,-3.905243 10.236893,-3.905243 14.142136,0 z" id="Rectangle-2" fill="#fefefe" fill-rule="nonzero" />
                    <path d="M 48,0 C 74.509668,0 96,21.490332 96,48 96,74.509668 74.509668,96 48,96 21.490332,96 0,74.509668 0,48 0,21.490332 21.490332,0 48,0 Z m 0,4 C 23.699471,4 4,23.699471 4,48 4,72.300529 23.699471,92 48,92 72.300529,92 92,72.300529 92,48 92,23.699471 72.300529,4 48,4 Z" id="path576" fill="#ffffff" fill-rule="nonzero" />
                  </g>
                </svg>
            </span>

            <vnc-icon-container *ngIf="!element?.starred" (click)="$event.stopPropagation();addToFavorite(element)" matTooltip="{{ 'ADD_TO_FAVOURITES' | translate }}">
              <ng-container [ngTemplateOutlet]="unstarIcon">
              </ng-container>
            </vnc-icon-container>
            <vnc-icon-container class="starred-icon" *ngIf="element?.starred" (click)="$event.stopPropagation();removeFromFavorite(element)" matTooltip="{{ 'REMOVE_FROM_FAVOURITES' | translate }}">
              <ng-container [ngTemplateOutlet]="starIcon">
              </ng-container>
            </vnc-icon-container>
            <button class="document-kebab-menu-btn" (click)="$event.stopPropagation();" #mainMenu="matMenuTrigger"
              mat-icon-button [matMenuTriggerFor]="menu" matTooltip="{{ 'MORE_TEXT' | translate }}">
              <ng-container [ngTemplateOutlet]="kebabIcon">
              </ng-container>
            </button>
            <mat-menu class="owncloud-menu" #menu="matMenu" [overlapTrigger]="false">
              <ng-template matMenuContent [ngTemplateOutlet]="menuTemplate"
                [ngTemplateOutletContext]="{'file': element}">
              </ng-template>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <!-- Size Column -->
      <ng-container matColumnDef="contentLength">
        <th mat-header-cell *matHeaderCellDef style="text-align: end;"> {{ 'SIZE' | translate }} </th>
        <td mat-cell *matCellDef="let element" style="text-align: end;"> {{ getFileSize(element?.size) }} </td>
      </ng-container>

      <!-- Modified Column -->
      <ng-container matColumnDef="lastModified">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container *ngIf="!currentFilter.value.startsWith('shared')">
            {{ 'MODIFIED' | translate }}
          </ng-container>
          <ng-container *ngIf="currentFilter.value.startsWith('shared')">
            {{ 'SHARE_TIME' | translate }}
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.lastModified">{{getTimeAgo(element?.lastModified)}} </ng-container>
          <ng-container *ngIf="element.sharedTime">{{getTimeAgo(element?.sharedTime)}} </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr [class.highlight]="shouldHighlight(row)" [class.is-selected]="selection.isSelected(row)" mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="openFolder(row)">
      </tr>
    </table>
    <table *ngIf="currentFilter.value.startsWith('shared')" mat-table [dataSource]="dataSource"
      class="mat-elevation-z8 vnc-scroll-bar--medium--vertical">

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> {{ 'NAME' | translate }} </th>
        <td mat-cell *matCellDef="let element">
          <div class="item-info">
            <div class="item-icon" *ngIf="element.type === 'dir'">
              <ng-container [ngTemplateOutlet]="folderIcon">
              </ng-container>
            </div>
            <ng-container *ngIf="element.type !== 'dir'">
              <ng-container [ngSwitch]="element.fileType">
                <div class="item-icon with-background" *ngSwitchDefault>
                  <ng-container [ngTemplateOutlet]="markupIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Pdf'">
                  <ng-container [ngTemplateOutlet]="pdfIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Word'">
                  <ng-container [ngTemplateOutlet]="wordIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Video'">
                  <ng-container [ngTemplateOutlet]="videoIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Autocad'">
                  <ng-container [ngTemplateOutlet]="cadIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'ApplePages'">
                  <ng-container [ngTemplateOutlet]="appleIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'XML'">
                  <ng-container [ngTemplateOutlet]="xmlIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Markup'">
                  <ng-container [ngTemplateOutlet]="markupIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Illustrator'">
                  <ng-container [ngTemplateOutlet]="aiIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Photoshop'">
                  <ng-container [ngTemplateOutlet]="psdIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'TaggedImage'">
                  <ng-container [ngTemplateOutlet]="tiffIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Vector'">
                  <ng-container [ngTemplateOutlet]="svgIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'PostScript'">
                  <ng-container [ngTemplateOutlet]="scriptIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'TrueType'">
                  <ng-container [ngTemplateOutlet]="ttfIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Powerpoint'">
                  <ng-container [ngTemplateOutlet]="powerpointIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Text'">
                  <ng-container [ngTemplateOutlet]="txtIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Archive'">
                  <ng-container [ngTemplateOutlet]="zipIcon">
                  </ng-container>
                </div>
                <div class="item-icon with-background" *ngSwitchCase="'Excel'">
                  <ng-container [ngTemplateOutlet]="excelIcon">
                  </ng-container>
                </div>
                <div class="item-icon" *ngSwitchCase="'Image'">
                  <div class="thumbnail" *ngIf="isNextCloud">
                    <img src="{{ getNextCloudPreviewUrl(element.fileId) }}" alt="" crossorigin="use-credentials" style="height: 36px; width: 36px;">
                  </div>
                  <div class="thumbnail" *ngIf="!isNextCloud">
                    <img src="{{ element.urlV2 }}?x=36&y=36&forceIcon=0&preview=1" alt="" crossorigin="use-credentials"></div>
                  </div>
                <div class="item-icon with-background" *ngSwitchCase="'Sound'">
                  <ng-container [ngTemplateOutlet]="audioIcon">
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
            <div class="item-name">
              <span *ngIf="element.type === 'file'" (click)="previewDocument(element)">{{element.name}}</span>
              <ng-container *ngIf="element.type !== 'file'">{{element.name}}</ng-container>
              <div (click)="$event.stopPropagation();$event.preventDefault()"
                *ngIf="fileToUpdate && fileToUpdate.fileId === element.fileId" class="rename-form">
                <vnc-input [form]="itemNameControl"></vnc-input>
                <vnc-primary-button (onClick)="updateFile(element)"
                  (click)="$event.stopPropagation();$event.preventDefault()" [leadingIconName]="'mdi-check'"
                  [size]="'l'" [isPending]="isPending"></vnc-primary-button>
                <vnc-secondary-button (onClick)="cancelUpdate()"
                  (click)="$event.stopPropagation();$event.preventDefault()" [size]="'l'" [isPending]="false"
                  [leadingIconName]="'mdi-close'"></vnc-secondary-button>

              </div>
            </div>
          </div>

        </td>
      </ng-container>

      <!-- Shared Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <div class="file-actions">
            <button class="document-kebab-menu-btn" (click)="$event.stopPropagation();"
              #shareMenuTrigger="matMenuTrigger" mat-icon-button [matMenuTriggerFor]="shareMenu" matTooltip="{{ 'SHARE' | translate }}">
              <ng-container [ngTemplateOutlet]="shareIcon">
              </ng-container>
            </button>
            <mat-menu class="owncloud-menu" #shareMenu="matMenu" [overlapTrigger]="false">
              <ng-template matMenuContent [ngTemplateOutlet]="shareMenuTemplate"
                [ngTemplateOutletContext]="{'file': element}">
              </ng-template>
            </mat-menu>
            <span (click)="$event.stopPropagation();" *ngIf="element.shareTypes !== 0" class="shared-text">
              {{ 'SHARED' | translate }}
            </span>
            <span (click)="$event.stopPropagation();" *ngIf="getSharedOwner(element, true) && (element?.ownerDisplayName.indexOf('@') === -1)" class="shared-text">
              {{element?.ownerDisplayName}}
            </span>
            <span (click)="$event.stopPropagation();" *ngIf="getSharedOwner(element, true) && (element?.ownerDisplayName.indexOf('@') > -1)" class="shared-text">
                <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Icon/vnc/iom-new-grayscale" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="matrix(0.22297838,0,0,0.22297838,1.4004701,1.6713882)">
                    <circle id="Oval" fill="#a8b0b9" fill-rule="nonzero" cx="48" cy="48" r="48" />
                    <path d="M 55.071068,19.715729 69.354797,33.999797 53.999,33.999229 54,30.273229 c 0,-0.250186 -0.09378,-0.491289 -0.262846,-0.675719 -0.373192,-0.407119 -1.00576,-0.434622 -1.412879,-0.06143 v 0 L 42,39 52.324275,48.463919 c 0.18443,0.169061 0.425533,0.262846 0.675725,0.262846 0.552285,0 1,-0.447715 1,-1 v 0 l -10e-4,-3.727536 24.382473,0.0012 c 1.595017,3.658954 0.89595,8.077466 -2.097202,11.070618 L 55.071068,76.284271 c -3.905243,3.905243 -10.236893,3.905243 -14.142136,0 L 26.643797,61.999797 42,61.999229 v 3.727536 c 0,0.250192 0.09378,0.491295 0.262846,0.675725 0.373192,0.407119 1.00576,0.434622 1.412879,0.06143 v 0 L 54,57 43.675725,47.536081 C 43.491295,47.36702 43.250192,47.273235 43,47.273235 c -0.552285,0 -1,0.447715 -1,1 v 0 3.725994 l -24.381035,0.0013 C 16.023382,48.341406 16.722303,43.922358 19.715729,40.928932 L 40.928932,19.715729 c 3.905243,-3.905243 10.236893,-3.905243 14.142136,0 z" id="Rectangle-2" fill="#fefefe" fill-rule="nonzero" />
                    <path d="M 48,0 C 74.509668,0 96,21.490332 96,48 96,74.509668 74.509668,96 48,96 21.490332,96 0,74.509668 0,48 0,21.490332 21.490332,0 48,0 Z m 0,4 C 23.699471,4 4,23.699471 4,48 4,72.300529 23.699471,92 48,92 72.300529,92 92,72.300529 92,48 92,23.699471 72.300529,4 48,4 Z" id="path576" fill="#ffffff" fill-rule="nonzero" />
                  </g>
                </svg>
            </span>

            <vnc-icon-container *ngIf="!element?.starred" (click)="$event.stopPropagation();addToFavorite(element)" matTooltip="{{ 'ADD_TO_FAVOURITES' | translate }}">
              <ng-container [ngTemplateOutlet]="unstarIcon">
              </ng-container>
            </vnc-icon-container>
            <vnc-icon-container class="starred-icon" *ngIf="element?.starred" (click)="$event.stopPropagation();removeFromFavorite(element)" matTooltip="{{ 'REMOVE_FROM_FAVOURITES' | translate }}">
              <ng-container [ngTemplateOutlet]="starIcon">
              </ng-container>
            </vnc-icon-container>
            <button class="document-kebab-menu-btn" (click)="$event.stopPropagation();" #mainMenu="matMenuTrigger"
              mat-icon-button [matMenuTriggerFor]="menu" matTooltip="{{ 'MORE_TEXT' | translate }}">
              <ng-container [ngTemplateOutlet]="kebabIcon">
              </ng-container>
            </button>
            <mat-menu class="owncloud-menu" #menu="matMenu" [overlapTrigger]="false">
              <ng-template matMenuContent [ngTemplateOutlet]="menuTemplate"
                [ngTemplateOutletContext]="{'file': element}">
              </ng-template>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <!-- Modified Column -->
      <ng-container matColumnDef="lastModified">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SHARE_TIME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.lastModified">{{getTimeAgo(element?.lastModified)}} </ng-container>
          <ng-container *ngIf="element.sharedTime">{{getTimeAgo(element?.sharedTime)}} </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="sharedColumns; sticky: true"></tr>
      <tr [class.highlight]="shouldHighlight(row)" [class.is-selected]="selection.isSelected(row)" mat-row *matRowDef="let row; columns: sharedColumns;"
        (click)="openFolder(row)">
      </tr>
    </table>
    <div *ngIf="isLoading" class="loading-attachments">
      <vnc-loader-circular color="blue" size="m"></vnc-loader-circular>
    </div>
  </div>
  <div class="owncloud-footer"  *ngIf="!isDialog || selection.selected.length === 0">
    {{ (totalFolders !== 1 ? 'TOTAL_N_FOLDERS' : 'TOTAL_FOLDER') | translate: {'total': totalFolders} }}, {{ (totalFiles
    !== 1 ?'TOTAL_N_FILES' : 'TOTAL_FILE') | translate: {'total': totalFiles} }}
  </div>
  <vnc-footer
  *ngIf="selection.selected.length > 0 && !!isDialog"
  secondaryLabel="{{ 'CANCEL' | translate }}"
  primaryLabel="{{ 'SEND' | translate }}"
  (onPrimaryClick)="send()"
  (onSecondaryClick)="resetSelection()"
  [type]="'secondary-primary'" [color]="'white'"></vnc-footer>
</div>
<div class="owncloud-component is-on-mobile"  [class.with-dialog]="isDialog" *ngIf="isMobileSize()">
    <div class="owncloud-navigation" *ngIf="isMobileSize()">
      <div class="home-icon">
        <vnc-icon-container (click)="home()">
          <ng-container [ngTemplateOutlet]="homeIcon">
          </ng-container>
        </vnc-icon-container>
        <span class="home-folder" (click)="home()">{{ 'OWNCLOUD' | translate }}</span>
      </div>
      <ng-container *ngIf="currentFolder && currentFilter.value === 'all'">
        <div class="separator-icon">
          <ng-container [ngTemplateOutlet]="separatorIcon">
          </ng-container>
        </div>
        <div class="more-text" (click)="backPreviousFolder()">
          ...
        </div>
        <div class="separator-icon">
          <ng-container [ngTemplateOutlet]="separatorIcon">
          </ng-container>
        </div>
        <div class="current-folder">
          {{ currentFolder?.name }}
        </div>
      </ng-container>
    </div>
  <div class="owncloud-files mobile-list vnc-scroll-bar--medium--vertical">
    <div *ngIf="isLoading" class="loading-attachments">
      <vnc-loader-circular color="blue" size="m"></vnc-loader-circular>
    </div>
    <vp-dropdown-item class="is-edited" *ngIf="newFolderObject"
    (saveClicked)="renameFolder($event)" (cancelClicked)="cancelRename()"
    [isEdited]="true" [element]="newFolderObject" itemType="owncloud-item"
    [label]="newFolderObject?.name">
 </vp-dropdown-item>
    <vp-dropdown-item *ngFor="let file of dataSource.data" [element]="file" itemType="owncloud-item"
      [fileAuther]="file.ownerDisplayName"
      [enableCheckbox]="true"
      [checked]="selection.isSelected(file)"
      (saveClicked)="itemNameControl.patchValue($event);updateFile(file)"
      (cancelClicked)="cancelUpdate()"
      (changeCheckEvent)="onItemCheck($event, file)"
      customMenuClass="custom-menu-mobile"
      backdropClass="mobile-menu-backdrop"
      [menuTemplate]="menuMobileTemplate"
      [isEdited]="fileToUpdate && fileToUpdate.fileId === file.fileId"
      (iconClicked)="selection.toggle(file)"
      [showOnHover]="!selection.selected.length"
      (descriptionClicked)="onFileClickedMobile(file)"
      (onClickEvent)="onFileClickedMobile(file)"
      [customMetaTemplate]="customMetaTemplate" [label]="file.name">
    </vp-dropdown-item>
    <div class="no-data-text" *ngIf="!isLoading && dataSource.data.length === 0">{{ 'NO_DATA_TO_DISPLAY' | translate }}</div>
  </div>
  <div class="owncloud-floating-actions" *ngIf="showMenu">
    <div class="menu-action action-one" (click)="$event.stopPropagation();uploadFile();showMenu = false;">
      <span class="tooltip">{{ 'UPLOAD_FILE' | translate }}</span>
      <vnc-floating-button [iconTemplate]="uploadIcon" *ngIf="showMenu" (onClick)="$event.stopPropagation();uploadFile();showMenu = false;" size="s" backgroundColor="blue500"></vnc-floating-button>
    </div>
    <div class="menu-action action-two" (click)="$event.stopPropagation();createFolder();showMenu = false">
      <span class="tooltip">{{ 'NEW_FOLDER' | translate }}</span>
      <vnc-floating-button [iconTemplate]="createFolderIcon" *ngIf="showMenu" (onClick)="$event.stopPropagation();createFolder();showMenu = false" size="s" backgroundColor="blue500"></vnc-floating-button>
    </div>
  </div>

  <vnc-floating-button id="owncloudFabBtn" *ngIf="!showMenu" (onClick)="showMenu = true" size="m" backgroundColor="blue500"></vnc-floating-button>
  <vnc-floating-button id="owncloudFabBtn" [iconTemplate]="closeIcon" *ngIf="showMenu" (onClick)="showMenu = false" size="m" backgroundColor="blue500"></vnc-floating-button>

</div>
<input id="selectFile" class="selectFile" title=" " (change)="attachFile($event)" multiple="true" type="file" />
<ng-template #closeIcon>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <filter x="-198.2%" y="-198.2%" width="496.4%" height="496.4%" filterUnits="objectBoundingBox" id="a">
            <feOffset dy="16" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="12" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.027713168 0 0 0 0 0.114145307 0 0 0 0 0.200577446 0 0 0 0.2 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>
            <feOffset dy="12" in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2"/>
            <feColorMatrix values="0 0 0 0 0.027713168 0 0 0 0 0.114145307 0 0 0 0 0.200577446 0 0 0 0.1 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="shadowMatrixOuter2"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g transform="rotate(90 28 12)" filter="url(#a)" fill="#FFF" fill-rule="evenodd">
        <path d="M35 22.41 33.59 21 28 26.59 22.41 21 21 22.41 26.59 28 21 33.59 22.41 35 28 29.41 33.59 35 35 33.59 29.41 28z"/>
    </g>
  </svg>
</ng-template>
<ng-template #uploadIcon>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <filter x="-26%" y="-26%" width="152.1%" height="152.1%" filterUnits="objectBoundingBox" id="a">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.027713168 0 0 0 0 0.114145307 0 0 0 0 0.200577446 0 0 0 0.2 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>
            <feOffset in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter2" result="shadowBlurOuter2"/>
            <feColorMatrix values="0 0 0 0 0.027713168 0 0 0 0 0.114145307 0 0 0 0 0.200577446 0 0 0 0.2 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="shadowMatrixOuter2"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g transform="translate(-12 -12)" filter="url(#a)" fill="#FFF" fill-rule="evenodd">
        <path d="M32 27.714a1 1 0 0 1 .993.884l.007.116v1.372c0 1.63-1.288 2.958-2.906 3.052l-.18.005H18.086c-1.641 0-2.988-1.27-3.082-2.877l-.005-.18v-1.372a1 1 0 0 1 1.993-.116l.007.116v1.372c0 .542.421.993.968 1.05l.119.007h11.826c.563 0 1.022-.415 1.08-.943l.007-.114v-1.372a1 1 0 0 1 1-1zM24 28a1 1 0 0 1-.993-.883L23 27v-8.584l-2.293 2.291a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 4-4a1 1 0 0 1 1.32-.083l.094.083 4 4a1 1 0 0 1-1.32 1.497l-.094-.083L25 18.416V27a1 1 0 0 1-1 1z"/>
    </g>
  </svg>
</ng-template>
<ng-template #createFolderIcon>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <filter x="-26%" y="-26%" width="152.1%" height="152.1%" filterUnits="objectBoundingBox" id="a">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.027713168 0 0 0 0 0.114145307 0 0 0 0 0.200577446 0 0 0 0.2 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"/>
            <feOffset in="SourceAlpha" result="shadowOffsetOuter2"/>
            <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter2" result="shadowBlurOuter2"/>
            <feColorMatrix values="0 0 0 0 0.027713168 0 0 0 0 0.114145307 0 0 0 0 0.200577446 0 0 0 0.2 0" in="shadowBlurOuter2" result="shadowMatrixOuter2"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="shadowMatrixOuter2"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </defs>
    <g transform="translate(-12 -12)" filter="url(#a)" fill="#FFF" fill-rule="evenodd">
        <path d="M21.01 16c.49 0 1.17.263 1.585.606l.116.105.578.578c.362.362 1.022.653 1.553.703l.155.008H32c1.05 0 1.918.82 1.994 1.851L34 20v10c0 1.05-.82 1.918-1.851 1.994L32 32H16c-1.05 0-1.918-.82-1.994-1.851L14 30l.01-12c0-1.05.81-1.918 1.841-1.994L16 16h5.01zm0 2-5 .002L16 30h16V20h-7.003c-1.012 0-2.183-.458-2.961-1.146l-.161-.15-.578-.579-.027-.015-.185-.081-.076-.029zM21 21a1 1 0 0 1 1 1v1.5h1.5a1 1 0 0 1 0 2H22V27a1 1 0 0 1-2 0v-1.5h-1.5a1 1 0 1 1 0-2H20V22a1 1 0 0 1 1-1z"/>
    </g>
  </svg>
</ng-template>

<ng-template #customMetaTemplate let-file="file">
  <div class="auther">
    <span class="star-icon" (click)="$event.stopPropagation();addToFavorite(file)" *ngIf="!file.starred">
      <ng-container [ngTemplateOutlet]="unstarIcon">
      </ng-container>
    </span>
    <span class="star-icon" (click)="$event.stopPropagation();removeFromFavorite(file)" *ngIf="file.starred">
      <ng-container [ngTemplateOutlet]="starIcon">
      </ng-container>
    </span>
    {{file.ownerDisplayName}}&nbsp;</div>
  <div class="file-date-time"> | {{ getFileSize(file.size) }} | {{getTimeAgo(file.lastModified)}} </div>
</ng-template>
<ng-template #folderIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g fill="#8B96A0">
        <g>
          <g>
            <g>
              <path
                d="M7.01 0c.49 0 1.17.263 1.585.606L8.71.71l.578.578c.362.362 1.022.653 1.553.703l.155.008H18c1.05 0 1.918.82 1.994 1.851L20 4v10c0 1.05-.82 1.918-1.851 1.994L18 16H2C.95 16 .082 15.18.006 14.149L0 14 .01 2C.01.95.82.082 1.851.006L2 0h5.01zm0 2l-5 .002L2 14h16V4h-7.003c-1.012 0-2.183-.458-2.961-1.146l-.161-.15-.578-.579-.027-.015-.185-.081L7.009 2z"
                transform="translate(-285.000000, -448.000000) translate(219.000000, 436.000000) translate(66.000000, 12.000000) translate(2.000000, 4.000000)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

</ng-template>

<ng-template #pdfIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g fill="#8B96A0">
        <g>
          <g>
            <g>
              <path
                d="M19 3c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h14zm0 2H5v14h14V5zm-7.61 1c.782.125 1.102.766.962 1.922-.141 1.156-.258 1.812-.352 1.969.313.937.79 1.703 1.43 2.296.64.594.992.891 1.054.891.47-.125 1.227-.164 2.274-.117s1.523.508 1.43 1.383c-.407.812-1.204 1.062-2.391.75-1.188-.313-1.86-.531-2.016-.656-1.219.124-2.219.289-3 .492-.781.203-1.187.32-1.219.351-.718 1.313-1.43 2.211-2.132 2.696-.703.484-1.242.476-1.617-.024-.25-.75.093-1.453 1.03-2.11.938-.655 1.485-1.015 1.641-1.077.875-1.47 1.446-2.61 1.711-3.422.266-.813.399-1.235.399-1.266-.219-.594-.344-1.39-.375-2.39-.031-1 .36-1.563 1.172-1.688zm-3.14 9.703c-.5.25-.922.625-1.266 1.125-.343.5-.468.781-.375.844.125 0 .36-.172.704-.516.343-.343.656-.828.937-1.453zm3.14-4.594c-.28.875-.593 1.649-.937 2.32-.344.673-.531 1.024-.562 1.055.5-.175 1.05-.34 1.65-.495l.459-.114 1.313-.281c-.72-.656-1.22-1.227-1.5-1.711-.282-.485-.422-.742-.422-.774zm3.938 2.72c.094.062.461.187 1.102.374.64.188 1.023.219 1.148.094-.031-.156-.328-.29-.89-.399-.563-.109-1.016-.132-1.36-.07zm-3.937-7.22c-.157.063-.204.407-.141 1.032s.11 1 .14 1.125c.032-.125.102-.485.212-1.079.109-.593.039-.953-.211-1.078z"
                transform="translate(-285.000000, -640.000000) translate(219.000000, 628.000000) translate(60.000000, 6.000000) translate(6.000000, 6.000000)" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

</ng-template>
<ng-template #wordIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g fill="#8B96A0" fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M15.984 0c.563 0 1.04.188 1.43.563.39.375.586.859.586 1.453v13.968c0 .563-.195 1.04-.586 1.43-.39.39-.867.586-1.43.586H2.016c-.563 0-1.04-.195-1.43-.586-.39-.39-.586-.867-.586-1.43V2.016C0 1.422.188.937.563.562.938.188 1.421 0 2.016 0zM6.32 4H4l1.215 10h3.363l.925-8.424.933 8.424h3.362L15 4h-2.32l-.475 6.218c-.009.11-.105.193-.215.184-.095-.007-.172-.081-.183-.176L11.099 4H7.9l-.708 6.226c-.012.11-.111.188-.221.176-.095-.011-.17-.088-.177-.184L6.32 4z"
                  transform="translate(-285.000000, -688.000000) translate(219.000000, 676.000000) translate(60.000000, 6.000000) translate(6.000000, 6.000000) translate(3.000000, 3.000000)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

</ng-template>

<ng-template #shareIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/share-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M12,14 C11.4871642,14 11.0644928,13.6139598 11.0067277,13.1166211 L11,13 L11,4.416 L9.70710678,5.70710678 C9.34662282,6.06759074 8.77939176,6.09532028 8.38710056,5.79029539 L8.29289322,5.70710678 C7.93240926,5.34662282 7.90467972,4.77939176 8.20970461,4.38710056 L8.29289322,4.29289322 L11.2928932,1.29289322 C11.6533772,0.932409257 12.2206082,0.904679722 12.6128994,1.20970461 L12.7071068,1.29289322 L15.7071068,4.29289322 C16.0976311,4.68341751 16.0976311,5.31658249 15.7071068,5.70710678 C15.3466228,6.06759074 14.7793918,6.09532028 14.3871006,5.79029539 L14.2928932,5.70710678 L13,4.416 L13,13 C13,13.5522847 12.5522847,14 12,14 Z M17.9134545,6.71428571 C19.5541721,6.71428571 20.9006635,7.98394317 20.9947487,9.59134269 L21,9.77128518 L21,18.0862111 C20.9994237,19.7169267 19.7119789,21.0443605 18.0944856,21.1376211 L17.9134545,21.1428571 L6.08654545,21.1428571 C4.44582791,21.1428571 3.0993365,19.8731997 3.0052513,18.2658002 L3,18.0858577 L3,9.7709318 C3.00057632,8.14021616 4.28802107,6.81278238 5.90551436,6.7195218 L6.08654545,6.71428571 L7.0005,6.71428571 C7.55250861,6.71428571 8,7.16177711 8,7.71378571 C8,8.26587881 7.55259316,8.71351958 7.00050014,8.71380816 L6.08688889,8.71428571 L6.08688889,8.71428571 C5.52375994,8.71447906 5.06518273,9.12956527 5.00637512,9.65671876 L5,9.77128518 L5,18.0858577 C5,18.6277017 5.42100438,19.0788675 5.96760257,19.1366148 L6.08654545,19.1428572 L17.9131111,19.1428572 C18.4762401,19.1426638 18.9348173,18.7275776 18.9936249,18.2004241 L19,18.0858577 L19,9.77128518 C19,9.22944112 18.5789956,8.77827533 18.0323974,8.72052808 L17.9134545,8.71428571 L16.9994999,8.71380807 C16.4474069,8.71351954 16,8.2658788 16,7.71378571 C16,7.16177711 16.4474914,6.71428571 16.9995,6.71428571 L17.9134545,6.71428571 L17.9134545,6.71428571 Z" id="Combined-Shape" fill="#8B96A0"></path>
    </g>
  </svg>
</ng-template>
<ng-template #homeIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <defs>
      <filter id="873ldqrm0a" color-interpolation-filters="auto">
        <feColorMatrix in="SourceGraphic"
          values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0" />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g
              transform="translate(-222.000000, -347.000000) translate(215.000000, 340.000000) translate(4.000000, 4.000000) translate(3.000000, 3.000000)">
              <g fill="#000">
                <path
                  d="M6 12.75L6 8.25 9 8.25 9 12.75 12.75 12.75 12.75 6.75 15 6.75 7.5 0 0 6.75 2.25 6.75 2.25 12.75z"
                  transform="translate(1.500000, 2.250000)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>

</ng-template>

<ng-template #addIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fill-rule="evenodd">
      <g fill="#000">
        <g>
          <g>
            <g>
              <g>
                <path d="M10.5 6L6 6 6 10.5 4.5 10.5 4.5 6 0 6 0 4.5 4.5 4.5 4.5 0 6 0 6 4.5 10.5 4.5z"
                  transform="translate(-529.000000, -347.000000) translate(522.000000, 340.000000) translate(4.000000, 4.000000) translate(3.000000, 3.000000) translate(3.750000, 3.750000)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #kebabIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/more-vert" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-24px" transform="translate(10.000000, 4.000000)" fill="#8B96A0">
              <path d="M2,4 C3.1,4 4,3.1 4,2 C4,0.9 3.1,0 2,0 C0.9,0 0,0.9 0,2 C0,3.1 0.9,4 2,4 L2,4 Z M2,6 C0.9,6 0,6.9 0,8 C0,9.1 0.9,10 2,10 C3.1,10 4,9.1 4,8 C4,6.9 3.1,6 2,6 L2,6 Z M2,12 C0.9,12 0,12.9 0,14 C0,15.1 0.9,16 2,16 C3.1,16 4,15.1 4,14 C4,12.9 3.1,12 2,12 L2,12 Z" id="Shape"></path>
          </g>
      </g>
  </svg>
</ng-template>

<ng-template #separatorIcon>

  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <g fill="#606B76">
        <g>
          <g>
            <path d="M14 6L15 6 11 18 10 18z"
              transform="translate(-320.000000, -344.000000) translate(250.000000, 344.000000) translate(70.000000, 0.000000)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #audioIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>92962D67-FC51-4B6B-A608-A27A6E5A07AF</title>
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1070.000000)" fill="#8B96A0">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                <g id="Icon/product/audiotrack" transform="translate(6.000000, 6.000000)">
                  <g id="Icon-24px" transform="translate(6.000000, 3.000000)">
                    <path
                      d="M6,0 L6,9.28 C5.53,9.11 5.03,9 4.5,9 C2.01,9 0,11.01 0,13.5 C0,15.99 2.01,18 4.5,18 C6.81,18 8.7,16.25 8.95,14 L9,14 L9,3 L13,3 L13,0 L6,0 L6,0 Z"
                      id="Shape"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #videoIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1134.000000)" fill="#8B96A0">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 64.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/camera-filled-new" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M12,5 C14.1421954,5 15.8910789,6.68396847 15.9951047,8.80035966 L16,9 L16,15 C16,17.1421954 14.3160315,18.8910789 12.1996403,18.9951047 L12,19 L5,19 C2.85780461,19 1.10892112,17.3160315 1.00489531,15.1996403 L1,15 L1,9 C1,6.85780461 2.68396847,5.10892112 4.80035966,5.00489531 L5,5 L12,5 Z M20.5425836,7.70208143 C21.4144016,7.1180865 22.5945711,7.35141313 23.178566,8.22323106 C23.3123319,8.4229237 23.4065884,8.64556331 23.4597758,8.90930817 L23.4919415,9.11510777 L23.5,9.28064743 L23.5,14.7186411 C23.5,15.7679821 22.649341,16.6186411 21.6,16.6186411 C21.359692,16.6186411 21.1223057,16.5730628 20.8736196,16.4705074 L20.6847641,16.3827296 L20.5427636,16.2973276 L17.8427636,14.4891546 C17.4300426,14.212758 17.1445442,13.7876818 17.0377508,13.2625835 L17.0088423,13.083913 L17,12.9104681 L17,11.0892663 C17,10.5926029 17.1942814,10.1189073 17.5710764,9.73799882 L17.7034184,9.61456165 L17.8425836,9.51070027 L20.5425836,7.70208143 Z"
                      id="Combined-Shape"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #txtIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>EF53BD55-B522-4A2D-B93C-F56DAB8E1510</title>
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1326.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 256.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-txt" transform="translate(6.000000, 6.000000)">
                    <g id="Icon-24px" transform="translate(3.000000, 3.000000)">
                      <path
                        d="M15.984375,0 C16.546875,0 17.0234375,0.1875 17.4140625,0.5625 C17.8046875,0.9375 18,1.421875 18,2.015625 L18,2.015625 L18,15.984375 C18,16.546875 17.8046875,17.0234375 17.4140625,17.4140625 C17.0234375,17.8046875 16.546875,18 15.984375,18 L15.984375,18 L2.015625,18 C1.453125,18 0.9765625,17.8046875 0.5859375,17.4140625 C0.1953125,17.0234375 0,16.546875 0,15.984375 L0,15.984375 L0,2.015625 C0,1.421875 0.1875,0.9375 0.5625,0.5625 C0.9375,0.1875 1.421875,0 2.015625,0 L2.015625,0 Z M6.27412692,5 L2,5 L2,6.43299663 L3.23019151,6.43299663 L3.23019151,13 L5.04919264,13 L5.04919264,6.43299663 L6.27412692,6.43299663 L6.27412692,5 Z M8.38753286,5 L6.62110402,5 L7.52534735,8.77643098 L6.53698836,13 L8.34547503,13 L9.00262861,9.4013468 L9.6597822,13 L11.4787833,13 L10.4851671,8.77643098 L11.3894104,5 L9.64926774,5 L8.99211416,8.27542088 L8.38753286,5 Z M16,5 L11.7258731,5 L11.7258731,6.43299663 L12.9560646,6.43299663 L12.9560646,13 L14.7750657,13 L14.7750657,6.43299663 L16,6.43299663 L16,5 Z"
                        id="symbol"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #markupIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1390.000000)" fill="#8B96A0">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 320.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-markupcode" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M18.984375,21 C19.546875,21 20.0234375,20.8046875 20.4140625,20.4140625 C20.8046875,20.0234375 21,19.546875 21,18.984375 L21,18.984375 L21,5.015625 C21,4.453125 20.8046875,3.9765625 20.4140625,3.5859375 C20.0234375,3.1953125 19.546875,3 18.984375,3 L18.984375,3 L5.015625,3 C4.453125,3 3.9765625,3.1953125 3.5859375,3.5859375 C3.1953125,3.9765625 3,4.453125 3,5.015625 L3,5.015625 L3,18.984375 C3,19.546875 3.1875,20.0234375 3.5625,20.4140625 C3.9375,20.8046875 4.421875,21 5.015625,21 L5.015625,21 L18.984375,21 Z M9.984375,18 L6,18 L6,6 L9.984375,6 L9.984375,8.015625 L8.015625,8.015625 L8.015625,15.984375 L9.984375,15.984375 L9.984375,18 Z M18,18 L14.015625,18 L14.015625,15.984375 L15.984375,15.984375 L15.984375,8.015625 L14.015625,8.015625 L14.015625,6 L18,6 L18,18 Z"
                      id="shape"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #excelIcon>
  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1518.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 448.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-excel-box" transform="translate(6.000000, 6.000000)">
                    <g id="Icon-24px" transform="translate(3.000000, 3.000000)">
                      <path
                        d="M15.984375,0 C16.546875,0 17.0234375,0.1875 17.4140625,0.5625 C17.8046875,0.9375 18,1.421875 18,2.015625 L18,2.015625 L18,15.984375 C18,16.546875 17.8046875,17.0234375 17.4140625,17.4140625 C17.0234375,17.8046875 16.546875,18 15.984375,18 L15.984375,18 L2.015625,18 C1.453125,18 0.9765625,17.8046875 0.5859375,17.4140625 C0.1953125,17.0234375 0,16.546875 0,15.984375 L0,15.984375 L0,2.015625 C0,1.421875 0.1875,0.9375 0.5625,0.5625 C0.9375,0.1875 1.421875,0 2.015625,0 L2.015625,0 Z M8.32595326,4 L5.32472325,4 L6.57441574,8.55672069 L5,14 L8.10947109,14 L9.03444034,9.51000953 L9.9397294,14 L13,14 L11.4551046,8.55672069 L12.6851169,4 L9.86100861,4 L9.07380074,8.16587226 L8.32595326,4 Z"
                        id="symbol"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #appleIcon>
  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>E435A669-B692-4441-A97B-72CA3F8C4496</title>
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1646.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 576.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-pages" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M18.984375,3 C19.546875,3 20.0234375,3.1875 20.4140625,3.5625 C20.8046875,3.9375 21,4.421875 21,5.015625 L21,5.015625 L21,17.698 L5,17.6989537 L5,19 L20.9999453,19.0006553 C20.9962076,19.5560759 20.8009133,20.0272117 20.4140625,20.4140625 C20.0234375,20.8046875 19.546875,21 18.984375,21 L18.984375,21 L5.015625,21 C4.453125,21 3.9765625,20.8046875 3.5859375,20.4140625 C3.1953125,20.0234375 3,19.546875 3,18.984375 L3,18.984375 L3,5.015625 C3,4.421875 3.1875,3.9375 3.5625,3.5625 C3.9375,3.1875 4.421875,3 5.015625,3 L5.015625,3 Z M9.78563854,12.0306047 L5.21879262,17.276857 L7.16850151,17.3001093 L11.3848413,13.6297641 L9.78563854,12.0306047 Z M18.0983702,5.31703245 C17.6756602,4.89427915 16.9877537,4.89436588 16.5651305,5.31703245 L16.5651305,5.31703245 L10.7385682,11.1435514 L12.2718946,12.6768344 L13.2225258,11.7262033 L14.1424956,12.6461731 L17.638407,9.15026175 C17.8841746,8.9044941 18.0194834,8.57775801 18.0194834,8.23024855 C18.0194834,7.88273909 17.8841746,7.556003 17.638407,7.31027873 L17.638407,7.31027873 L18.0983702,6.8503155 C18.5211235,6.42760556 18.5211235,5.73978576 18.0983702,5.31703245 Z"
                      id="symbol"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #aiIcon>
  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1710.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 640.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-ai" transform="translate(6.000000, 6.000000)">
                    <g id="Icon-24px" transform="translate(3.000000, 3.000000)">
                      <path
                        d="M15.984375,0 C16.546875,0 17.0234375,0.1875 17.4140625,0.5625 C17.8046875,0.9375 18,1.421875 18,2.015625 L18,2.015625 L18,15.984375 C18,16.546875 17.8046875,17.0234375 17.4140625,17.4140625 C17.0234375,17.8046875 16.546875,18 15.984375,18 L15.984375,18 L2.015625,18 C1.453125,18 0.9765625,17.8046875 0.5859375,17.4140625 C0.1953125,17.0234375 0,16.546875 0,15.984375 L0,15.984375 L0,2.015625 C0,1.421875 0.1875,0.9375 0.5625,0.5625 C0.9375,0.1875 1.421875,0 2.015625,0 L2.015625,0 Z M9.32525516,4.17207148 L5.73962568,4.17207148 C5.64134059,4.17207148 5.55762169,4.2434849 5.54212676,4.34054089 L4,14 L6.45647914,14 L6.74756482,11.5843812 L8.30238832,11.5843812 L8.593474,14 L11.1067503,14 L9.52261914,4.33970699 C9.50676614,4.2430328 9.42322055,4.17207148 9.32525516,4.17207148 Z M13.8488058,7.05757776 L11.8488058,7.05757776 L11.8488058,14 L13.8488058,14 L13.8488058,7.05757776 Z M7.56100465,6.78874834 C7.6525155,6.80009168 7.7244098,6.87253032 7.73506259,6.96412413 L8.08229915,9.94970218 L6.96765399,9.94970218 L7.33792073,6.96262635 C7.35150856,6.85300834 7.45138664,6.7751605 7.56100465,6.78874834 Z M12.8488058,4 C12.2965211,4 11.8488058,4.44771525 11.8488058,5 C11.8488058,5.55228475 12.2965211,6 12.8488058,6 C13.4010906,6 13.8488058,5.55228475 13.8488058,5 C13.8488058,4.44771525 13.4010906,4 12.8488058,4 Z"
                        id="symbol"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #psdIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1774.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 704.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-psd" transform="translate(6.000000, 6.000000)">
                    <g id="Icon-24px" transform="translate(3.000000, 3.000000)">
                      <path
                        d="M15.9811519,0 C16.5435385,0 17.0200049,0.187462193 17.4105511,0.562386578 C17.8010974,0.937310963 17.9963705,1.42158829 17.9963705,2.01521857 L17.9963705,2.01521857 L17.9963705,15.9811519 C17.9963705,16.5435385 17.8010974,17.0200049 17.4105511,17.4105511 C17.0200049,17.8010974 16.5435385,17.9963705 15.9811519,17.9963705 L15.9811519,17.9963705 L2.01521857,17.9963705 C1.45283199,17.9963705 0.976365586,17.8010974 0.585819352,17.4105511 C0.195273117,17.0200049 0,16.5435385 0,15.9811519 L0,15.9811519 L0,2.01521857 C0,1.42158829 0.187462193,0.937310963 0.562386578,0.562386578 C0.937310963,0.187462193 1.42158829,0 2.01521857,0 L2.01521857,0 Z M13.1553615,6.78110446 L12.2556957,6.78110446 C11.5825645,6.78110446 11.0960546,6.93302284 10.796166,7.23685961 C10.5295983,7.50693674 10.3815052,7.92683768 10.3518866,8.49656243 L10.3463331,8.7172322 L10.3463331,9.53559548 C10.3463331,9.95697494 10.4218446,10.2585939 10.5728676,10.4404524 C10.7238907,10.6223109 11.0539839,10.7731204 11.5631472,10.8928809 C11.7141703,10.9328011 11.9105002,10.9727212 12.1521371,11.0126414 C12.7573079,11.1346196 13.0851088,11.3292766 13.1355397,11.5966123 L13.1424167,11.671324 L13.1424167,12.1104458 C13.1424167,12.2834331 13.100346,12.4109559 13.0162046,12.493014 C12.9320632,12.5750721 12.8015361,12.6161011 12.6246234,12.6161011 C12.4088762,12.6161011 12.2643256,12.5584387 12.1909716,12.4431138 C12.1280967,12.3442639 12.0921682,12.1509091 12.083186,11.8630494 L12.0809405,11.7112442 L10.3074986,11.7112442 L10.3074986,12.243513 C10.3074986,12.908849 10.4466555,13.3679308 10.7249694,13.6207585 C10.9754519,13.8483034 11.4137962,13.9734531 12.0400025,13.9962076 L12.2556957,14 L12.773489,14 C13.6235329,14 14.2071291,13.8558439 14.5242774,13.5675316 C14.809711,13.3080506 14.9666994,12.8581504 14.9952428,12.217831 L15,11.9973387 L15,11.1656687 C15,10.6910623 14.8964413,10.3395431 14.689324,10.1111111 C14.4822067,9.88267909 14.1046492,9.72188955 13.5566513,9.62874251 C13.4530926,9.5976935 13.3462978,9.56997117 13.2362667,9.54557552 C13.1262356,9.52117986 13.002181,9.49567532 12.8641028,9.46906188 C12.4097392,9.37325349 12.1598392,9.21636727 12.1144029,8.99840319 L12.1068302,8.92348636 L12.1068302,8.53759148 C12.1068302,8.40008871 12.1553733,8.29363495 12.2524595,8.21823021 C12.3495458,8.14282546 12.4822303,8.10512309 12.6505131,8.10512309 C12.8490005,8.10512309 12.9849212,8.13728099 13.0582753,8.20159681 C13.1169585,8.25304946 13.1521685,8.34069639 13.1639051,8.46453759 L13.1683063,8.56420492 L13.1683063,8.9500998 L14.9029138,8.9500998 L14.9029138,8.4510978 C14.9029138,8.14060767 14.8673155,7.87558217 14.7961189,7.65602129 C14.7249223,7.43646041 14.6245999,7.26679973 14.4951516,7.14703925 C14.2688567,6.930189 13.8908464,6.80971664 13.3611204,6.78562217 L13.1553615,6.78110446 Z M6.25240068,4 L4,4 L4,13.8802395 L6.23945585,13.8802395 L6.23945585,11.0725216 L6.60838354,11.0725216 C7.76910343,11.0725216 8.56736804,10.8862275 9.00317737,10.5136394 C9.40266925,10.1721002 9.61906069,9.59016227 9.65235168,8.76782546 L9.65689136,8.53759148 L9.65689136,6.53493014 C9.65689136,5.56797516 9.43251428,4.90374806 8.98376012,4.54224884 C8.56492291,4.20484956 7.74389457,4.02490328 6.52067512,4.00240999 L6.25240068,4 Z M6.73783186,5.74318031 C7.00104343,5.74318031 7.17795613,5.7941894 7.26856995,5.89620758 C7.34408147,5.98122274 7.38812985,6.12476282 7.4007151,6.32682783 L7.40449068,6.45508982 L7.40449068,8.5508982 C7.40449068,8.82590375 7.35810503,9.01330672 7.26533374,9.11310712 C7.17256245,9.21290752 6.99672849,9.26280772 6.73783186,9.26280772 L6.23945585,9.26280772 L6.23945585,5.74318031 L6.73783186,5.74318031 Z"
                        id="symbol"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #tiffIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1838.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 768.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-tiff" transform="translate(6.000000, 6.000000)">
                    <g id="Icon-24px" transform="translate(3.000000, 3.000000)">
                      <path
                        d="M15.984375,0 C16.546875,0 17.0234375,0.1875 17.4140625,0.5625 C17.8046875,0.9375 18,1.421875 18,2.015625 L18,2.015625 L18,15.984375 C18,16.546875 17.8046875,17.0234375 17.4140625,17.4140625 C17.0234375,17.8046875 16.546875,18 15.984375,18 L15.984375,18 L2.015625,18 C1.453125,18 0.9765625,17.8046875 0.5859375,17.4140625 C0.1953125,17.0234375 0,16.546875 0,15.984375 L0,15.984375 L0,2.015625 C0,1.421875 0.1875,0.9375 0.5625,0.5625 C0.9375,0.1875 1.421875,0 2.015625,0 L2.015625,0 Z M5.36071069,5 L1,5 L1,6.43299663 L2.2551123,6.43299663 L2.2551123,13 L4.11096212,13 L4.11096212,6.43299663 L5.36071069,6.43299663 L5.36071069,5 Z M7.91384512,5 L6.05799531,5 L6.05799531,13 L7.91384512,13 L7.91384512,5 Z M12.6285619,5 L9.13677506,5 L9.13677506,13 L10.9926249,13 L10.9926249,9.85387205 L12.4730137,9.85387205 L12.4730137,8.42087542 L10.9926249,8.42087542 L10.9926249,6.43299663 L12.6285619,6.43299663 L12.6285619,5 Z M17,5 L13.5082132,5 L13.5082132,13 L15.364063,13 L15.364063,9.85387205 L16.8444519,9.85387205 L16.8444519,8.42087542 L15.364063,8.42087542 L15.364063,6.43299663 L17,6.43299663 L17,5 Z"
                        id="symbol"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #cadIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1902.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 832.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-autodesk" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M18.984375,3 C19.546875,3 20.0234375,3.1875 20.4140625,3.5625 C20.8046875,3.9375 21,4.421875 21,5.015625 L21,5.015625 L21,18.984375 C21,19.546875 20.8046875,20.0234375 20.4140625,20.4140625 C20.0234375,20.8046875 19.546875,21 18.984375,21 L18.984375,21 L5.015625,21 C4.453125,21 3.9765625,20.8046875 3.5859375,20.4140625 C3.1953125,20.0234375 3,19.546875 3,18.984375 L3,18.984375 L3,5.015625 C3,4.421875 3.1875,3.9375 3.5625,3.5625 C3.9375,3.1875 4.421875,3 5.015625,3 L5.015625,3 Z M9.79770525,6 C9.41854442,6 9.28772398,6.22657467 9.24449317,6.3432071 L9.24449317,6.3432071 L6.16172468,13.7025378 C6.06787642,13.9369725 6,14.0520051 6,14.2629441 C6,14.4118853 6.00170924,14.4807345 6.1089414,14.6874509 L6.1089414,14.6874509 L7.66500257,17.571971 C7.83535371,17.8711898 8.01281012,18 8.35429439,18 C8.884091,18 9.63917014,17.5710628 9.83770109,17.4536484 L9.83770109,17.4536484 L13.9107566,14.9304786 L9.00752858,14.9304786 L11.465,9.115 L15.2188831,17.9995447 L18.6024024,17.9995447 L13.6816886,6.34907744 C13.6140283,6.18223119 13.4655597,6 13.1560683,6 L13.1560683,6 Z"
                      id="symbol"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>


<ng-template #svgIcon>
  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -1966.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 896.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-svg" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M18.984375,3 C19.546875,3 20.0234375,3.1875 20.4140625,3.5625 C20.8046875,3.9375 21,4.421875 21,5.015625 L21,5.015625 L21,18.984375 C21,19.546875 20.8046875,20.0234375 20.4140625,20.4140625 C20.0234375,20.8046875 19.546875,21 18.984375,21 L18.984375,21 L5.015625,21 C4.453125,21 3.9765625,20.8046875 3.5859375,20.4140625 C3.1953125,20.0234375 3,19.546875 3,18.984375 L3,18.984375 L3,5.015625 C3,4.421875 3.1875,3.9375 3.5625,3.5625 C3.9375,3.1875 4.421875,3 5.015625,3 L5.015625,3 Z M6.35634451,8 L5.81985536,8 C5.153627,8 4.68376068,8.13762875 4.41025641,8.41288626 C4.16410256,8.66061801 4.02871795,9.08231427 4.00410256,9.67797502 L4,9.88297173 L4,10.6035503 C4,11.1575718 4.09467456,11.5634451 4.28402367,11.8211703 C4.44970414,12.0466798 4.73619329,12.228564 5.14349112,12.3668228 L5.32544379,12.4234057 L5.78303748,12.5338593 C6.22134561,12.6355468 6.49660311,12.7547666 6.60880999,12.8915187 C6.6579005,12.9546351 6.69296515,13.0273943 6.71400394,13.1097962 C6.72978304,13.1715976 6.73964497,13.2565746 6.74358974,13.3647272 L6.74556213,13.4806049 L6.74556213,14.0328731 C6.74556213,14.2572869 6.70962086,14.4098181 6.63773833,14.4904668 C6.5658558,14.5711155 6.42296735,14.6114398 6.20907298,14.6114398 C6.0162174,14.6114398 5.87946526,14.5693623 5.79881657,14.4852071 C5.73429761,14.417883 5.69558624,14.3124085 5.68268245,14.1687837 L5.67784352,14.0539119 L5.67784352,13.2965155 L4,13.2965155 L4,14.1485865 C4,14.8533859 4.1455183,15.3381547 4.4365549,15.6028928 C4.69848784,15.8411571 5.15355687,15.9722025 5.801762,15.9960289 L6.02498356,16 L6.50887574,16 C7.21016875,16 7.71597633,15.8562349 8.02629849,15.5687048 C8.3021404,15.3131225 8.45538591,14.913472 8.48603502,14.3697535 L8.49178172,14.1591059 L8.49178172,13.1071663 C8.49178172,12.5601578 8.39710717,12.1595442 8.20775805,11.9053254 C8.04207758,11.6828841 7.75827307,11.5054104 7.35634451,11.3729043 L7.17685733,11.3188692 L6.73504274,11.1978961 C6.13719044,11.0436117 5.81335379,10.8009351 5.76353276,10.4698663 L5.75673899,10.3773833 L5.75673899,9.87245233 C5.75673899,9.66907736 5.79005041,9.52881876 5.85667324,9.45167653 C5.93030901,9.3745343 6.06180145,9.33596318 6.25115056,9.33596318 C6.45101907,9.33596318 6.58338812,9.37628753 6.64825773,9.45693623 C6.70231573,9.52414347 6.73384956,9.64857428 6.74285923,9.83022865 L6.74556213,9.9460881 L6.74556213,10.43524 L8.36028928,10.43524 L8.36028928,9.83037475 C8.36028928,9.42011834 8.33486741,9.11768573 8.28402367,8.92307692 C8.23317993,8.72846811 8.14814815,8.5715538 8.02892834,8.45233399 C7.87464387,8.29454306 7.66162612,8.17970633 7.38987508,8.1078238 C7.17247425,8.05031777 6.90850756,8.01581416 6.59797502,8.00431295 L6.35634451,8 Z M17.21762,8 C16.8950252,8 16.6285339,8.00876616 16.418146,8.02629849 C16.2077581,8.04383081 16.0359413,8.0701293 15.9026956,8.10519395 C15.6362043,8.17882972 15.4258163,8.30067938 15.2715319,8.47074293 C15.1172474,8.64080649 15.0094236,8.83979838 14.9480605,9.06771861 C14.8943677,9.26714881 14.8641656,9.58067609 14.857454,10.0083005 L14.8560158,10.1985536 L14.8560158,13.8067061 C14.8560158,14.3256629 14.887574,14.7043612 14.9506903,14.9428008 C15.0138067,15.1812404 15.1190007,15.3793557 15.2662722,15.5371466 C15.431076,15.7124699 15.6300679,15.8334429 15.8632479,15.9000657 C16.0964278,15.9666886 16.5478852,16 17.21762,16 C17.8522902,16 18.2905983,15.9649353 18.5325444,15.894806 C18.7744905,15.8246767 18.9699759,15.7054569 19.1190007,15.5371466 C19.2680254,15.3688363 19.3723428,15.1672146 19.4319527,14.9322814 C19.4830469,14.7309101 19.5122436,14.4264917 19.5195427,14.0190262 L19.5213675,13.8067061 L19.5213675,11.6607495 L17.2596976,11.6607495 L17.2596976,13.0598291 L17.7751479,13.0598291 L17.7751479,14.0644313 C17.7751479,14.2818321 17.73833,14.4273504 17.6646943,14.5009862 C17.5910585,14.574622 17.4455402,14.6114398 17.2281394,14.6114398 C17.0037256,14.6114398 16.8555775,14.574622 16.7836949,14.5009862 C16.7261889,14.4420776 16.6916853,14.3371641 16.6801841,14.1862459 L16.6758711,14.0644313 L16.6758711,9.9460881 C16.6758711,9.73219373 16.7109358,9.58667543 16.7810651,9.5095332 C16.8617138,9.43589744 17.0107385,9.39907955 17.2281394,9.39907955 C17.4490467,9.39907955 17.5954416,9.43765067 17.6673241,9.5147929 C17.7248302,9.57650668 17.7593338,9.68085908 17.770835,9.8278501 L17.7751479,9.9460881 L17.7751479,10.6035503 L19.5108481,10.6035503 L19.5108481,10.1985536 C19.5108481,9.67258383 19.4792899,9.29213237 19.4161736,9.05719921 C19.3530572,8.82226605 19.2513697,8.62765724 19.1111111,8.47337278 C18.9463073,8.29804953 18.7315363,8.17532325 18.4667982,8.10519395 C18.20206,8.03506465 17.7856673,8 17.21762,8 Z M10.9690993,8.09467456 L9.09664694,8.09467456 L10.1854043,15.9053254 L13.1045365,15.9053254 L14.2038133,8.09467456 L12.3261012,8.09467456 L11.6370809,14.9375411 L10.9690993,8.09467456 Z"
                      id="symbol"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #scriptIcon>
  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -2030.000000)" fill="#8B96A0">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 960.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-eps" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M14,6 L21,6 L21,8 L15.8768872,8.00048842 C18.0593297,9.21188388 19.6156981,11.4143641 19.9381123,14.0000487 L21,14 L21,18 L17,18 L17,14 L17.9170737,14.0001915 C17.5533918,11.831996 16.0268618,10.0580828 14.0006859,9.34165389 L14,10 L10,10 L10.0003218,9.34129768 C7.97364431,10.0574947 6.44666851,11.8316366 6.08292631,14.0001915 L7,14 L7,18 L3,18 L3,14 L4.06188768,14.0000487 C4.38430189,11.4143641 5.94067033,9.21188388 8.12311277,8.00048842 L3,8 L3,6 L10,6 L14,6 Z M6,15 L4,15 L4,17 L6,17 L6,15 Z M20,15 L20,17 L18,17 L18,15 L20,15 Z M13,7 L13,9 L11,9 L11,7 L13,7 Z"
                      id="Shape"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>
<ng-template #ttfIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -2094.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 1024.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-ttf" transform="translate(6.000000, 6.000000)">
                    <g id="Icon-24px" transform="translate(3.000000, 3.000000)">
                      <path
                        d="M15.984375,0 C16.546875,0 17.0234375,0.1875 17.4140625,0.5625 C17.8046875,0.9375 18,1.421875 18,2.015625 L18,2.015625 L18,15.984375 C18,16.546875 17.8046875,17.0234375 17.4140625,17.4140625 C17.0234375,17.8046875 16.546875,18 15.984375,18 L15.984375,18 L2.015625,18 C1.453125,18 0.9765625,17.8046875 0.5859375,17.4140625 C0.1953125,17.0234375 0,16.546875 0,15.984375 L0,15.984375 L0,2.015625 C0,1.421875 0.1875,0.9375 0.5625,0.5625 C0.9375,0.1875 1.421875,0 2.015625,0 L2.015625,0 Z M6.47955921,5 L2,5 L2,6.43299663 L3.28931962,6.43299663 L3.28931962,13 L5.1957495,13 L5.1957495,6.43299663 L6.47955921,6.43299663 L6.47955921,5 Z M11.6158312,5 L7.13627195,5 L7.13627195,6.43299663 L8.42559158,6.43299663 L8.42559158,13 L10.3320214,13 L10.3320214,6.43299663 L11.6158312,6.43299663 L11.6158312,5 Z M16,5 L12.4130467,5 L12.4130467,13 L14.3194766,13 L14.3194766,9.85387205 L15.8402125,9.85387205 L15.8402125,8.42087542 L14.3194766,8.42087542 L14.3194766,6.43299663 L16,6.43299663 L16,5 Z"
                        id="symbol"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #xmlIcon>

  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -2158.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 1088.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon/product/file-xml" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M18.984375,3 C19.546875,3 20.0234375,3.1875 20.4140625,3.5625 C20.8046875,3.9375 21,4.421875 21,5.015625 L21,5.015625 L21,18.984375 C21,19.546875 20.8046875,20.0234375 20.4140625,20.4140625 C20.0234375,20.8046875 19.546875,21 18.984375,21 L18.984375,21 L5.015625,21 C4.453125,21 3.9765625,20.8046875 3.5859375,20.4140625 C3.1953125,20.0234375 3,19.546875 3,18.984375 L3,18.984375 L3,5.015625 C3,4.421875 3.1875,3.9375 3.5625,3.5625 C3.9375,3.1875 4.421875,3 5.015625,3 L5.015625,3 Z M5.66479456,9 L4.07567248,9 L4.88915164,12.3043771 L4,16 L5.62695832,16 L6.21814957,12.8511785 L6.80934082,16 L8.4457582,16 L7.55187703,12.3043771 L8.36535619,9 L6.79988176,9 L6.20869051,11.8659933 L5.66479456,9 Z M11.5057641,9 L9.13626958,9 L9.13626958,16 L10.5503991,16 L10.483149,12.6352698 C10.4809417,12.5248349 10.5686776,12.4335205 10.6791125,12.4313132 C10.7775195,12.4293464 10.8627291,12.4992716 10.8800044,12.5961704 L11.486846,16 L13.298256,16 L13.9487863,12.4621694 C13.968762,12.3535337 14.0730222,12.2816607 14.1816579,12.3016364 C14.2778202,12.3193186 14.3471017,12.4039352 14.3454604,12.501696 L14.2867278,16 L15.7670706,16 L15.7670706,9 L13.4354124,9 L12.4469406,14.5245791 L11.5057641,9 Z M18.4534437,9 L16.8170263,9 L16.8170263,16 L20,16 L20,14.7461279 L18.4534437,14.7461279 L18.4534437,9 Z"
                      id="symbol"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #zipIcon>
  <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Channels" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="0232.-Smart-link-#12-01" transform="translate(-68.000000, -2222.000000)" fill="#8B96A0"
        fill-rule="nonzero">
        <g id="Sidepanel/channels/files-all-formatss" transform="translate(45.000000, 741.000000)">
          <g id="Group-3" transform="translate(0.000000, 8.000000)">
            <g id="Group-6" transform="translate(0.000000, 301.000000)">
              <g id="Dropdown/item/@xl/file-icon-avatar" transform="translate(0.000000, 1152.000000)">
                <g id="File-list/item/@l/file-list-Copy-2" transform="translate(17.777778, 14.000000)">
                  <g id="Icon-24px" transform="translate(6.000000, 6.000000)">
                    <path
                      d="M18.984375,21 C19.546875,21 20.0234375,20.8046875 20.4140625,20.4140625 C20.8046875,20.0234375 21,19.546875 21,18.984375 L21,5.015625 C21,4.421875 20.8046875,3.9375 20.4140625,3.5625 C20.0234375,3.1875 19.546875,3 18.984375,3 L5.015625,3 C4.421875,3 3.9375,3.1875 3.5625,3.5625 C3.1875,3.9375 3,4.421875 3,5.015625 L3,18.984375 C3,19.546875 3.1953125,20.0234375 3.5859375,20.4140625 C3.9765625,20.8046875 4.453125,21 5.015625,21 L18.984375,21 Z M12,6.984375 L9.984375,6.984375 L9.984375,5.015625 L12,5.015625 L12,6.984375 Z M12,15 L9.984375,15 L9.984375,12.984375 L12,12.984375 L12,15 Z M12,11.015625 L14.015625,11.015625 L14.015625,12.984375 L12,12.984375 L12,11.015625 Z M12,9 L12,11.015625 L9.984375,11.015625 L9.984375,9 L12,9 Z M12,6.984375 L14.015625,6.984375 L14.015625,9 L12,9 L12,6.984375 Z M12,15 L14.015625,15 L14.015625,17.015625 L12,17.015625 L12,15 Z"
                      id=""></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</ng-template>

<ng-template #powerpointIcon>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter x="-9.6%" y="-15.7%" width="119.2%" height="131.4%" filterUnits="objectBoundingBox" id="a">
        <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0.031372549 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.2 0"
          in="shadowBlurOuter1" result="shadowMatrixOuter1" />
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
        <feColorMatrix values="0 0 0 0 0.0311856736 0 0 0 0 0.177658465 0 0 0 0 0.240432518 0 0 0 0.1 0"
          in="shadowBlurOuter2" result="shadowMatrixOuter2" />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g transform="translate(-60 -44)" filter="url(#a)" fill="#8B96A0" fill-rule="nonzero">
      <path
        d="m85.313 48 .221.008a2.572 2.572 0 0 1 1.685.773c.52.521.781 1.157.781 1.907v18.624l-.008.222a2.572 2.572 0 0 1-.773 1.685c-.521.52-1.156.781-1.906.781H66.686l-.221-.008a2.572 2.572 0 0 1-1.685-.773A2.594 2.594 0 0 1 64 69.313V50.686l.006-.212c.044-.695.302-1.27.775-1.725.521-.5 1.156-.75 1.906-.75h18.626zm-10.128 5.333H72v13.334h3.167v-3.79h.522c1.641 0 2.77-.25 3.387-.754.575-.469.882-1.274.92-2.416l.004-.25v-2.703c0-1.305-.317-2.201-.952-2.689-.597-.459-1.773-.702-3.527-.73l-.336-.002zm.687 2.353c.372 0 .622.069.75.206.11.118.173.32.189.605l.004.15v2.828c0 .37-.066.624-.197.758-.131.135-.38.202-.746.202h-.705v-4.75h.705z" />
    </g>
  </svg>
</ng-template>
<ng-template #newFolderIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/folder-add-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-24px" transform="translate(2.000000, 4.000000)" fill="#8B96A0">
              <path d="M7.00922203,0 C7.49995184,0 8.18025928,0.262988878 8.59481703,0.605726148 L8.71075654,0.71075654 L9.28924346,1.28924346 C9.65129486,1.65129486 10.3113868,1.94247309 10.8421188,1.99242242 L10.9970301,2 L18,2 C19.05,2 19.9177686,2.82004132 19.9944872,3.85130541 L20,4 L20,14 C20,15.05 19.1799587,15.9177686 18.1486946,15.9944872 L18,16 L2,16 C0.95,16 0.082231405,15.1799587 0.00551277235,14.1486946 L0,14 L0.01,2 C0.01,0.95 0.820929752,0.082231405 1.85136551,0.00551277235 L2,0 L7.00922203,0 Z M7.00922203,2 L2.00999931,2.00166667 L2,14 L18,14 L18,4 L10.9970301,4 C9.98506984,4 8.81419501,3.54226902 8.03565409,2.85431634 L7.8750299,2.70345702 L7.29654298,2.1249701 L7.27022108,2.10994272 L7.0847011,2.02870664 L7.00922203,2 Z M7,5 C7.55228475,5 8,5.44771525 8,6 L8,7.5 L9.5,7.5 C10.0522847,7.5 10.5,7.94771525 10.5,8.5 C10.5,9.05228475 10.0522847,9.5 9.5,9.5 L8,9.5 L8,11 C8,11.5522847 7.55228475,12 7,12 C6.44771525,12 6,11.5522847 6,11 L6,9.5 L4.5,9.5 C3.94771525,9.5 3.5,9.05228475 3.5,8.5 C3.5,7.94771525 3.94771525,7.5 4.5,7.5 L6,7.5 L6,6 C6,5.44771525 6.44771525,5 7,5 Z" id="Combined-Shape"></path>
          </g>
      </g>
  </svg>
</ng-template>
<ng-template #uploadFileIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/upload-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M20,15.7142857 C20.5128358,15.7142857 20.9355072,16.1003259 20.9932723,16.5976646 L21,16.7142857 L21,18.0862111 C20.9994237,19.7169267 19.7119789,21.0443605 18.0944856,21.1376211 L17.9134545,21.1428571 L6.08654545,21.1428571 C4.44582791,21.1428571 3.0993365,19.8731997 3.0052513,18.2658002 L3,18.0858577 L3,16.7142857 C3,16.162001 3.44771525,15.7142857 4,15.7142857 C4.51283584,15.7142857 4.93550716,16.1003259 4.99327227,16.5976646 L5,16.7142857 L5,18.0858577 C5,18.6277017 5.42100438,19.0788675 5.96760257,19.1366148 L6.08654545,19.1428571 L17.9131111,19.1428572 C18.4762401,19.1426638 18.9348173,18.7275776 18.9936249,18.2004241 L19,18.0858577 L19,16.7142857 C19,16.162001 19.4477153,15.7142857 20,15.7142857 Z M12,16 C11.4871642,16 11.0644928,15.6139598 11.0067277,15.1166211 L11,15 L11,6.416 L8.70710678,8.70710678 C8.34662282,9.06759074 7.77939176,9.09532028 7.38710056,8.79029539 L7.29289322,8.70710678 C6.93240926,8.34662282 6.90467972,7.77939176 7.20970461,7.38710056 L7.29289322,7.29289322 L11.2928932,3.29289322 C11.6533772,2.93240926 12.2206082,2.90467972 12.6128994,3.20970461 L12.7071068,3.29289322 L16.7071068,7.29289322 C17.0976311,7.68341751 17.0976311,8.31658249 16.7071068,8.70710678 C16.3466228,9.06759074 15.7793918,9.09532028 15.3871006,8.79029539 L15.2928932,8.70710678 L13,6.416 L13,15 C13,15.5522847 12.5522847,16 12,16 Z" id="Shape" fill="#8B96A0"></path>
      </g>
  </svg>

</ng-template>

<ng-template #shareMenuTemplate let-file="file">
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="shareWithUsers(file)" [prefixIconTemplate]="usersIcon"
    label="{{ 'SHARE_WITH_USERS_AND_GROUPS' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="sharePublicLink(file)" [prefixIconTemplate]="linkIcon"
    label="{{ 'SHARE_A_PUBLIC_LINK' | translate }}"></vp-dropdown-item>
</ng-template>

<ng-template #menuTemplate let-file="file">
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="showDetails(file)" [prefixIconTemplate]="infoIcon"
    label="{{ 'DETAILS' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="renameFile(file)" [prefixIconTemplate]="editIcon"
    label="{{ 'RENAME_LBL' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="download(file)" [prefixIconTemplate]="downloadIcon"
    label="{{ 'DOWNLOAD_LBL' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="delete(file)" [prefixIconTemplate]="deleteIcon"
    label="{{ 'DELETE' | translate }}"></vp-dropdown-item>
</ng-template>

<ng-template #menuMobileTemplate let-file="file">
  <vp-dropdown-item  itemType="menu-item" (onClickEvent)="showDetails(file)" [prefixIconTemplate]="infoIcon"
    label="{{ 'DETAILS' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="renameFile(file)" [prefixIconTemplate]="editIcon"
    label="{{ 'RENAME_LBL' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="download(file)" [prefixIconTemplate]="downloadIcon"
    label="{{ 'DOWNLOAD_LBL' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="delete(file)" [prefixIconTemplate]="deleteIcon"
    label="{{ 'DELETE' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="shareWithUsers(file)" [prefixIconTemplate]="usersIcon"
    label="{{ 'SHARE_WITH_USERS_AND_GROUPS' | translate }}"></vp-dropdown-item>
  <vp-dropdown-item itemType="menu-item" (onClickEvent)="sharePublicLink(file)" [prefixIconTemplate]="linkIcon"
    label="{{ 'SHARE_A_PUBLIC_LINK' | translate }}"></vp-dropdown-item>
  <div class="menu-divider"></div>
  <vp-dropdown-item class="" itemType="menu-item" [prefixIconTemplate]="cancelIcon"
    label="{{ 'CANCEL' | translate }}"></vp-dropdown-item>
</ng-template>
<ng-template #cancelIcon>
  <svg class="default-color" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.95 5.05a1 1 0 0 1 0 1.414L13.414 12l5.536 5.536a1 1 0 0 1-1.414 1.414L12 13.414 6.464 18.95a1 1 0 1 1-1.414-1.414L10.586 12 5.05 6.464A1 1 0 0 1 6.464 5.05L12 10.586l5.536-5.536a1 1 0 0 1 1.414 0z" fill="#8B96A0" fill-rule="nonzero"/>
  </svg>
</ng-template>

<ng-template #infoIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/info-outline" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M11,17 L13,17 L13,11 L11,11 L11,17 L11,17 Z M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 L12,20 Z M11,9 L13,9 L13,7 L11,7 L11,9 L11,9 Z" id="icon" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>

<ng-template #editIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/edit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-24px" transform="translate(3.000000, 2.997500)" fill="#8B96A0">
              <path d="M0,14.2525 L0,18.0025 L3.75,18.0025 L14.81,6.9425 L11.06,3.1925 L0,14.2525 L0,14.2525 Z M17.71,4.0425 C18.1,3.6525 18.1,3.0225 17.71,2.6325 L15.37,0.2925 C14.98,-0.0975 14.35,-0.0975 13.96,0.2925 L12.13,2.1225 L15.88,5.8725 L17.71,4.0425 L17.71,4.0425 Z" id="Shape"></path>
          </g>
      </g>
  </svg>
</ng-template>

<ng-template #downloadIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/download-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M20,15.7142857 C20.5128358,15.7142857 20.9355072,16.1003259 20.9932723,16.5976646 L21,16.7142857 L21,18.0862111 C20.9994237,19.7169267 19.7119789,21.0443605 18.0944856,21.1376211 L17.9134545,21.1428571 L6.08654545,21.1428571 C4.44582791,21.1428571 3.0993365,19.8731997 3.0052513,18.2658002 L3,18.0858577 L3,16.7142857 C3,16.162001 3.44771525,15.7142857 4,15.7142857 C4.51283584,15.7142857 4.93550716,16.1003259 4.99327227,16.5976646 L5,16.7142857 L5,18.0858577 C5,18.6277017 5.42100438,19.0788675 5.96760257,19.1366148 L6.08654545,19.1428571 L17.9131111,19.1428572 C18.4762401,19.1426638 18.9348173,18.7275776 18.9936249,18.2004241 L19,18.0858577 L19,16.7142857 C19,16.162001 19.4477153,15.7142857 20,15.7142857 Z M12,3 C12.5128358,3 12.9355072,3.38604019 12.9932723,3.88337887 L13,4 L13,12.584 L15.2928932,10.2928932 C15.6533772,9.93240926 16.2206082,9.90467972 16.6128994,10.2097046 L16.7071068,10.2928932 C17.0675907,10.6533772 17.0953203,11.2206082 16.7902954,11.6128994 L16.7071068,11.7071068 L12.7071068,15.7071068 C12.3466228,16.0675907 11.7793918,16.0953203 11.3871006,15.7902954 L11.2928932,15.7071068 L7.29289322,11.7071068 C6.90236893,11.3165825 6.90236893,10.6834175 7.29289322,10.2928932 C7.65337718,9.93240926 8.22060824,9.90467972 8.61289944,10.2097046 L8.70710678,10.2928932 L11,12.584 L11,4 C11,3.44771525 11.4477153,3 12,3 Z" id="Shape" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>

<ng-template #deleteIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/delete-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M18,7 L6,7 L6,18.2857143 C6,19.7746499 7.19131256,21 8.66666667,21 L15.3333333,21 C16.8086874,21 18,19.7746499 18,18.2857143 L18,7 Z M8,9 L16,9 L16,18.2857143 C16,18.6824929 15.6913126,19 15.3333333,19 L8.66666667,19 L8.57834889,18.9935231 C8.25938319,18.9465317 8,18.649428 8,18.2857143 L8,9 Z M13,3 C13.7404864,3 14.3869825,3.40242038 14.7327215,4.00049436 L18,4 C18.5522847,4 19,4.44771525 19,5 C19,5.55228475 18.5522847,6 18,6 L6,6 C5.44771525,6 5,5.55228475 5,5 C5,4.44771525 5.44771525,4 6,4 L9.26760632,3.99992752 C9.61342606,3.40216612 10.2597476,3 11,3 L13,3 Z" id="Combined-Shape" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>

<ng-template #usersIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/user-group-add-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M17.0200669,15 C18.2684805,15 19.6256389,15.2698679 21.0933947,15.802083 C22.6901796,16.3810846 23.6943144,17.3096583 23.9554613,18.5874988 L23.9904987,18.7921655 L24,18.9296875 L24,20 C24,20.5522847 23.5522847,21 23,21 C22.4477153,21 22,20.5522847 22,20 L22,19.018 L21.9890465,18.9596418 C21.8769203,18.4982387 21.4565107,18.0982351 20.6136736,17.7593992 L20.4116221,17.682292 C19.1502808,17.2249238 18.019145,17 17.0200669,17 C16.4790809,17 15.8973878,17.0659418 15.2753572,17.1990199 C15.6193671,17.604295 15.8490713,18.0669129 15.9554613,18.5874988 L15.9904987,18.7921655 L16,18.9296875 L16,21 C16,21.5522847 15.5522847,22 15,22 C14.4477153,22 14,21.5522847 14,21 L14,19.018 L13.9890465,18.9596418 C13.8855454,18.5337312 13.5193649,18.1601374 12.8007277,17.838678 L12.6136736,17.7593992 L12.4116221,17.682292 C11.1502808,17.2249238 10.019145,17 9.02006689,17 C8.02016749,17 6.88120553,17.2252689 5.60551489,17.6833493 C4.61546028,18.0388623 4.13204451,18.4652381 4.01095357,18.9601165 L4,19.013 L4,21 C4,21.5522847 3.55228475,22 3,22 C2.44771525,22 2,21.5522847 2,21 L2,18.9296875 L2.00950129,18.7921655 C2.20198853,17.4057812 3.23452212,16.4097023 4.92960216,15.8010257 C6.40976437,15.2695228 7.77247466,15 9.02006689,15 C10.2447692,15 11.5741248,15.259714 13.0098825,15.7720416 L12.9296022,15.8010257 C14.4097644,15.2695228 15.7724747,15 17.0200669,15 Z M8.5,7 C9.47989383,7 10.331491,7.33426357 10.995667,7.99325071 C11.6613811,8.65376395 12,9.50303011 12,10.4804688 C12,11.4579074 11.6613811,12.3071735 10.995667,12.9676868 C10.3416985,13.6165461 9.51178209,13.9642177 8.484272,13.9993728 C7.50450726,13.9646545 6.66056681,13.6187937 6.00433302,12.9676868 C5.33861889,12.3071735 5,11.4579074 5,10.4804688 C5,9.50303011 5.33861889,8.65376395 6.00433302,7.99325071 C6.66850903,7.33426357 7.52010617,7 8.5,7 Z M17.5,7 C18.4798938,7 19.331491,7.33426357 19.995667,7.99325071 C20.6613811,8.65376395 21,9.50303011 21,10.4804688 C21,11.4579074 20.6613811,12.3071735 19.995667,12.9676868 C19.3394332,13.6187937 18.4954927,13.9646545 17.4435921,13.9993255 C16.4882179,13.9642177 15.6583015,13.6165461 15.004333,12.9676868 C14.3386189,12.3071735 14,11.4579074 14,10.4804688 C14,9.50303011 14.3386189,8.65376395 15.004333,7.99325071 C15.668509,7.33426357 16.5201062,7 17.5,7 Z M8.5,9 C8.03632428,9 7.69369569,9.13448643 7.41298981,9.41299929 C7.13382206,9.68998605 7,10.0256157 7,10.4804688 C7,10.9353218 7.13382206,11.2709515 7.41298981,11.5479382 C7.70163792,11.8343313 8.06504655,11.9832621 8.48296214,12.0006745 C8.94491082,11.983699 9.29609673,11.8365789 9.58701019,11.5479382 C9.86617794,11.2709515 10,10.9353218 10,10.4804688 C10,10.0256157 9.86617794,9.68998605 9.58701019,9.41299929 C9.30630431,9.13448643 8.96367572,9 8.5,9 Z M17.5,9 C17.0363243,9 16.6936957,9.13448643 16.4129898,9.41299929 C16.1338221,9.68998605 16,10.0256157 16,10.4804688 C16,10.9353218 16.1338221,11.2709515 16.4129898,11.5479382 C16.7039033,11.8365789 17.0550892,11.983699 17.4449019,12.0006272 C17.9349535,11.9832621 18.2983621,11.8343313 18.5870102,11.5479382 C18.8661779,11.2709515 19,10.9353218 19,10.4804688 C19,10.0256157 18.8661779,9.68998605 18.5870102,9.41299929 C18.3063043,9.13448643 17.9636757,9 17.5,9 Z M5,1 L5,4 L8,4 L8,6 L5,6 L5,9 L3,9 L3,6 L0,6 L0,4 L3,4 L3,1 L5,1 Z" id="Combined-Shape" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>
<ng-template #linkIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/footer-links" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M10.1015625,15.375 C10.3671875,15.375 10.6015625,15.2734375 10.8046875,15.0703125 C11.0078125,14.8671875 11.109375,14.6328125 11.109375,14.3671875 C11.109375,14.1015625 11.015625,13.859375 10.828125,13.640625 C10.234375,13.015625 9.9375,12.3046875 9.9375,11.5078125 C9.9375,10.7109375 10.234375,10.015625 10.828125,9.421875 L14.34375,5.859375 C14.96875,5.265625 15.6796875,4.96875 16.4765625,4.96875 C17.2734375,4.96875 17.9765625,5.2734375 18.5859375,5.8828125 C19.1953125,6.4921875 19.5,7.1953125 19.5,7.9921875 C19.5,8.7890625 19.203125,9.5 18.609375,10.125 L18.140625,10.59375 C18.421875,11.375 18.546875,12.1875 18.515625,13.03125 L20.015625,11.53125 C20.984375,10.5 21.46875,9.3203125 21.46875,7.9921875 C21.46875,6.6640625 20.984375,5.484375 20.015625,4.453125 C18.984375,3.484375 17.8046875,3 16.4765625,3 C15.1484375,3 13.96875,3.484375 12.9375,4.453125 L9.421875,8.015625 C8.421875,9.015625 7.921875,10.1875 7.921875,11.53125 C7.921875,12.875 8.421875,14.046875 9.421875,15.046875 C9.609375,15.265625 9.8359375,15.375 10.1015625,15.375 Z M7.9921875,21.46875 C9.3203125,21.46875 10.5,20.984375 11.53125,20.015625 L15.046875,16.453125 C16.046875,15.453125 16.546875,14.28125 16.546875,12.9375 C16.546875,11.59375 16.046875,10.421875 15.046875,9.421875 C14.859375,9.203125 14.6328125,9.09375 14.3671875,9.09375 C14.1015625,9.09375 13.859375,9.203125 13.640625,9.421875 C13.453125,9.609375 13.359375,9.8359375 13.359375,10.1015625 C13.359375,10.3671875 13.453125,10.609375 13.640625,10.828125 C14.234375,11.453125 14.53125,12.1640625 14.53125,12.9609375 C14.53125,13.7578125 14.234375,14.453125 13.640625,15.046875 L10.125,18.609375 C9.5,19.203125 8.7890625,19.5 7.9921875,19.5 C7.1953125,19.5 6.4921875,19.1953125 5.8828125,18.5859375 C5.2734375,17.9765625 4.96875,17.2734375 4.96875,16.4765625 C4.96875,15.6796875 5.265625,14.96875 5.859375,14.34375 L6.328125,13.875 C6.046875,13.09375 5.921875,12.28125 5.953125,11.4375 L4.453125,12.9375 C3.484375,13.96875 3,15.1484375 3,16.4765625 C3,17.8046875 3.484375,18.984375 4.453125,20.015625 C5.484375,20.984375 6.6640625,21.46875 7.9921875,21.46875 Z" id="shape" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>


<ng-template #unstarIcon>
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Icon/product/favorites-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon-24px" transform="translate(1.505671, 1.540769)" fill="#8B96A0">
            <path d="M6.9983286,6.14323104 L1.40953093,6.61799276 L1.26460357,6.63518784 C-0.0552054556,6.83794505 -0.44917403,8.20493004 0.598745785,9.11274336 L4.8433286,12.789231 L3.56851214,18.2545538 L3.54091129,18.3929441 C3.32282074,19.7132073 4.50160138,20.5142266 5.69036612,19.7967359 L10.4943286,16.897231 L15.2982911,19.7967359 L15.421404,19.8657141 C16.6098776,20.4807549 17.7355842,19.6067107 17.4201451,18.2545538 L16.1443286,12.789231 L20.3899114,9.11274336 L20.4968956,9.01361095 C21.4441276,8.07347077 20.9616162,6.73528328 19.5791263,6.61799276 L13.9893286,6.14323104 L11.805765,0.99087528 C11.2452509,-0.33161867 9.74228122,-0.328964184 9.18289224,0.99087528 L6.9983286,6.14323104 Z M8.36972948,8.03467405 L10.4943286,3.02023104 L12.6189277,8.03467405 L18.0483286,8.49523104 L13.9233514,12.0686154 L15.1623286,17.378231 L10.4943286,14.5612051 L5.8253286,17.378231 L7.06530584,12.0686154 L2.9393286,8.49523104 L8.36972948,8.03467405 Z" id="Shape"></path>
        </g>
    </g>
</svg>
</ng-template>

<ng-template #starIcon>
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="m6.378 5.763-4.192.356-.108.013c-.99.152-1.286 1.177-.5 1.858l3.184 2.758-.956 4.098-.021.104c-.164.99.72 1.591 1.612 1.053L9 13.83l3.603 2.174.092.052c.892.461 1.736-.194 1.5-1.209l-.957-4.098 3.184-2.758.08-.074c.71-.705.348-1.709-.688-1.797l-4.193-.356-1.637-3.864c-.42-.992-1.548-.99-1.968 0L6.378 5.763z" fill="#FFAD16" fill-rule="evenodd"/>
  </svg>

</ng-template>

<ng-template #leadingIconName>
  <svg width="18" height="19" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.625 10.59h-.592l-.21-.202A4.853 4.853 0 0 0 12 7.216a4.875 4.875 0 1 0-4.875 4.875 4.853 4.853 0 0 0 3.172-1.178l.203.21v.593l3.75 3.742 1.117-1.117-3.742-3.75zm-4.5 0A3.37 3.37 0 0 1 3.75 7.217 3.37 3.37 0 0 1 7.125 3.84 3.37 3.37 0 0 1 10.5 7.216a3.37 3.37 0 0 1-3.375 3.375z"
      fill="#8B96A0" fill-rule="evenodd" />
  </svg>
</ng-template>

<ng-template #tagIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/tag-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M11,2 C11.5,2 11.9259259,2.14814815 12.2777778,2.44444444 L12.40625,2.5625 L21.40625,11.5625 C21.78125,11.9375 21.96875,12.40625 21.96875,12.96875 C21.96875,13.46875 21.8206019,13.8946759 21.5243056,14.2465278 L21.40625,14.375 L14.375,21.40625 C14,21.78125 13.53125,21.96875 12.96875,21.96875 C12.46875,21.96875 12.0428241,21.8206019 11.6909722,21.5243056 L11.5625,21.40625 L2.5625,12.40625 C2.22916667,12.0729167 2.04398148,11.6655093 2.00694444,11.1840278 L2,11 L2,3.96875 C2,3.40625 2.1875,2.9375 2.5625,2.5625 C2.89583333,2.22916667 3.30324074,2.04398148 3.78472222,2.00694444 L3.96875,2 L11,2 Z M11.013,3.997 L11,4 L4,4 L4,11 L3.997,11.013 L12.954,19.97 L12.96875,19.96875 L12.982,19.97 L19.97,12.982 L19.96875,12.96875 L19.97,12.954 L11.013,3.997 Z M6.4921875,5.015625 C6.9140625,5.015625 7.265625,5.15625 7.546875,5.4375 C7.828125,5.71875 7.96875,6.0703125 7.96875,6.4921875 C7.96875,6.9140625 7.828125,7.265625 7.546875,7.546875 C7.265625,7.828125 6.90625,7.96875 6.46875,7.96875 C6.0625,7.96875 5.71875,7.828125 5.4375,7.546875 C5.15625,7.265625 5.015625,6.9140625 5.015625,6.4921875 C5.015625,6.0703125 5.15625,5.71875 5.4375,5.4375 C5.71875,5.15625 6.0703125,5.015625 6.4921875,5.015625 Z" id="Combined-Shape" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>

<ng-template #searchIcon>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#606B76" fill-rule="evenodd"/>
  </svg>
</ng-template>